import { htmlE } from "/WebInterface/new-ui/assets/js/utils/te.js";
// NOTE: Dynamic inline styles have been removed for CSP compliance.
// Styles must be applied via JavaScript after element creation using _$(el).css().

const GridItem = htmlE`
  <div class="w-full has-text-centered icon-wrapper is-relative">
    ${({ audio }) =>
      audio ? `<div class="audio-preview-wrapper">${audio}</div>` : ""}
    ${({ image }) => image}
    ${({ protocol, protocolIcon }) =>
      protocolIcon
        ? `<div data-tooltip="${encodeURIComponent(
            utils.sanitizePure(protocol)
          )}" class="is-absolute is-flex is-align-items-center is-justify-content-center file-protocol-sticker">
        ${protocolIcon}
        </div>`
        : ""}
    ${({ syncText, showSyncIcon }) =>
      showSyncIcon
        ? `<div data-tooltip="${encodeURIComponent(
            utils.sanitizePure(syncText)
          )}" class="is-absolute is-flex is-align-items-center is-justify-content-center file-sync-sticker">
            <i class="icon-tags"></i>
            </div>`
        : ""}
    ${({
      totalSubscribedEvents,
      subscribedEventsDirectoryPath,
      showSubscribedEventsIcon,
    }) =>
      showSubscribedEventsIcon
        ? `<span data-tooltip="subscribedToEventsCount" data-tooltip-i18n-opt='{"eventCounts": "${encodeURIComponent(
            utils.sanitizePure(totalSubscribedEvents)
          )}"}' id="subscribed_events_${encodeURIComponent(
            utils.decodeURILocal(subscribedEventsDirectoryPath) || ""
          )}_label" class="subscribed-events-label ${
            !totalSubscribedEvents ? "is-invisible" : ""
          }">${utils.textEncode(String(totalSubscribedEvents ?? ""))}</span>`
        : ""}
  </div>
  <p class="text-primaryMain file-title">${"name"}</p>
  ${({ showNumItems, num_items, itemsText }) =>
    num_items && showNumItems
      ? `<p
      class="w-full has-text-centered text-xs">
      ${num_items} <span data-i18n-key="items">${itemsText}</span>
      </p>`
      : ""}
`;

const TreeHeader = htmlE`<div class="table-responsive h-full list-table bg-primaryMain">
  <table cellpadding="0" cellspacing="0" class="table h-full is-fullwidth is-flex is-flex-direction-column">
    <thead>
      <tr class="is-flex">
      ${({ canCheckboxColumnDisable }) => {
        if (!canCheckboxColumnDisable) {
          return `<th
          id="checkTh"
          preferredPortion="38"
          preferredPortionUnit="px"
          class="w-38px is-cursor-pointer table-header is-flex is-justify-content-space-between is-align-items-center"
        >
          <label for="checkAll" class="is-sr-only">Select All</label>
          <input type="checkbox" id="checkAll" />
        </th>`;
        }
        return "";
      }}
        ${({
          canNameColumnDisable,
          prefixId,
          name,
          nameColumnOrder,
          nameColumnMinWidth,
          nameColumnWidth,
        }) => {
          if (!canNameColumnDisable) {
            return `<th
            preferredPortion="40"
            preferredPortionUnit="%"
            id="${prefixId}-name-sort-list"
            class="is-flex is-justify-content-space-between is-align-items-center is-cursor-pointer is-clipped is-ellipsis table-header"
            data-width="${nameColumnWidth}" data-min-width="${nameColumnMinWidth}" data-order="${nameColumnOrder}"
          >
            <span data-i18n-key="name" class="whitespace-nowrap">${name}</span>
          </th>`;
          }
          return "";
        }}
        ${({
          canPathColumnEnable,
          isSearchFilterActive,
          prefixId,
          path,
          pathColumnOrder,
          pathColumnMinWidth,
          pathColumnWidth,
        }) => {
          if (canPathColumnEnable || isSearchFilterActive) {
            return `<th
            id="${prefixId}-root_dir-sort-list"
            data-width="${pathColumnWidth}" data-min-width="${pathColumnMinWidth}" data-order="${pathColumnOrder}"
            class="is-flex is-justify-content-space-between is-align-items-center is-cursor-pointer w-full is-clipped is-ellipsis table-header"
          >
            <span data-i18n-key="path" class="whitespace-nowrap">${path}</span>
          </th>`;
          }
          return "";
        }}
        ${({
          canSizeColumnDisable,
          prefixId,
          size,
          sizeColumnOrder,
          sizeColumnMinWidth,
          sizeColumnWidth,
        }) => {
          if (!canSizeColumnDisable) {
            return `<th
            id="${prefixId}-size-sort-list"
            class="is-flex is-justify-content-space-between is-align-items-center is-cursor-pointer w-full is-clipped is-ellipsis table-header"
            data-width="${sizeColumnWidth}" data-min-width="${sizeColumnMinWidth}" data-order="${sizeColumnOrder}"
          >
            <span data-i18n-key="size" class="whitespace-nowrap">${size}</span>
          </th>`;
          }
          return "";
        }}
        ${({
          canModifiedColumnDisable,
          prefixId,
          lastModified,
          modifiedColumnOrder,
          modifiedColumnMinWidth,
          modifiedColumnWidth,
        }) => {
          if (!canModifiedColumnDisable) {
            return `<th
            id="${prefixId}-modified-sort-list"
            data-width="${modifiedColumnWidth}" data-min-width="${modifiedColumnMinWidth}" data-order="${modifiedColumnOrder}"
            class="is-flex is-justify-content-space-between is-align-items-center is-cursor-pointer w-full is-clipped is-ellipsis table-header"
          >
            <span data-i18n-key="lastModified" class="whitespace-nowrap"
              >${lastModified}</span
            >
          </th>`;
          }
          return "";
        }}
        ${({
          canCreatedColumnEnable,
          prefixId,
          created,
          createdColumnOrder,
          createdColumnMinWidth,
          createdColumnWidth,
        }) => {
          if (canCreatedColumnEnable) {
            return `<th
            id="${prefixId}-created-sort-list"
            data-width="${createdColumnWidth}" data-min-width="${createdColumnMinWidth}" data-order="${createdColumnOrder}"
            class="is-flex is-justify-content-space-between is-align-items-center is-cursor-pointer w-full is-clipped is-ellipsis table-header"
          >
            <span data-i18n-key="created" class="whitespace-nowrap"
              >${created}</span
            >
          </th>`;
          }
          return "";
        }}
        ${({
          canKeywordColumnDisable,
          prefixId,
          keyword,
          keywordsColumnOrder,
          keywordsColumnMinWidth,
          keywordsColumnWidth,
        }) => {
          if (!canKeywordColumnDisable) {
            return `<th
            id="${prefixId}-keywords-sort-list"
            class="is-flex is-justify-content-space-between is-align-items-center is-cursor-pointer w-full is-clipped is-ellipsis table-header"
            data-width="${keywordsColumnWidth}" data-min-width="${keywordsColumnMinWidth}" data-order="${keywordsColumnOrder}"
          >
            <span data-i18n-key="keywords" class="whitespace-nowrap"
              >${keyword}</span
            >
          </th>`;
          }
          return "";
        }}
      </tr>
    </thead>
    <tbody class="table-body h-full" id="${"prefixId"}-virtual-list"></tbody>
  </table>
</div>`;

const TreeItem = htmlE`
${({ canCheckboxColumnDisable, checked, rowIndex }) => {
  if (!canCheckboxColumnDisable) {
    const checkboxID = `checkbox_${rowIndex || "1"}_${Math.floor(
      Math.random() * 100000
    )}`;
    return `
      <td class="table-td check-td w-38px">
      <label for="${checkboxID}" class="is-sr-only">Check item</label>
        <input ${checked} id="${checkboxID}" class="checks is-cursor-pointer" type="checkbox" />
      </td>
    `;
  }
  return "";
}}
${({
  canNameColumnDisable,
  paddingLeft,
  image,
  audio,
  name,
  num_items,
  itemsText,
  protocol,
  protocolIcon,
  showNumItems,
  nameColumnOrder,
  nameColumnMinWidth,
  nameColumnWidth,
  totalSubscribedEvents,
  showSubscribedEventsIcon,
  subscribedEventsDirectoryPath,
  isDir,
  syncText,
  showSyncIcon,
}) => {
  if (!canNameColumnDisable) {
    return `
      <td class="name-td table-td is-flex is-align-items-center gap-2 is-relative" data-width="${nameColumnWidth}" data-min-width="${nameColumnMinWidth}" data-padding-left="${paddingLeft}" data-order="${nameColumnOrder}">
        ${
          protocolIcon
            ? `<div data-tooltip="${encodeURIComponent(
                utils.sanitizePure(protocol)
              )}" class="file-protocol-sticker bg-secondaryMain">${protocolIcon}</div>`
            : ""
        }

        ${
          showSyncIcon
            ? `<div class="h-25px w-25px">
          ${
            syncText
              ? `<span data-tooltip="${encodeURIComponent(
                  utils.sanitizePure(syncText)
                )}" class="file-sync-sticker bg-secondaryMain">
            <i class="icon-tags"></i></span>`
              : ""
          }
            </div>`
            : ""
        }

        ${
          showSubscribedEventsIcon
            ? `<span data-tooltip="subscribedToEventsCount" data-tooltip-i18n-opt='{"eventCounts": "${encodeURIComponent(
                utils.sanitizePure(totalSubscribedEvents)
              )}"}' id="subscribed_events_${encodeURIComponent(
                utils.decodeURILocal(subscribedEventsDirectoryPath) || ""
              )}_label" class="subscribed-events-label ${
                !isDir || !totalSubscribedEvents ? "is-invisible" : ""
              }">${utils.textEncode(String(totalSubscribedEvents ?? ""))}</span>`
            : ""
        }

        <div tabindex="0" class="w-full is-flex is-align-items-center name is-justify-content-space-between">
          <div class="w-full is-flex is-align-items-center icon-name-wrapper">
            <div class="is-flex">${image}</div>
            <p class="is-clipped is-ellipsis file-name-text">${name}</p>
            ${audio ? `<div class="audio-preview-wrapper">${audio}</div>` : ""}
          </div>
        </div>

        ${
          num_items && showNumItems
            ? `<span class="has-text-right">(${num_items} <span data-i18n-key="items">${itemsText}</span>)</span>`
            : ""
        }
      </td>
    `;
  }
  return "";
}}
${({
  canPathColumnEnable,
  isSearchFilterActive,
  path,
  pathColumnOrder,
  pathColumnMinWidth,
  pathColumnWidth,
}) => {
  if (canPathColumnEnable || isSearchFilterActive) {
    return `
      <td class="path-td table-td" data-width="${pathColumnWidth}" data-min-width="${pathColumnMinWidth}" data-order="${pathColumnOrder}">
        <p class="w-full is-clipped is-ellipsis">${path}</p>
      </td>
    `;
  }
  return "";
}}
${({
  canSizeColumnDisable,
  sizeFormatted,
  sizeColumnOrder,
  sizeColumnMinWidth,
  sizeColumnWidth,
}) => {
  if (!canSizeColumnDisable) {
    return `
      <td class="size-td table-td" data-width="${sizeColumnWidth}" data-min-width="${sizeColumnMinWidth}" data-order="${sizeColumnOrder}">
        <p class="w-full is-clipped is-ellipsis">${sizeFormatted}</p>
      </td>
    `;
  }
  return "";
}}
${({
  canModifiedColumnDisable,
  dateFormatted,
  modifiedColumnOrder,
  modifiedColumnMinWidth,
  modifiedColumnWidth,
}) => {
  if (!canModifiedColumnDisable) {
    return `
      <td class="modified-td table-td" data-width="${modifiedColumnWidth}" data-min-width="${modifiedColumnMinWidth}" data-order="${modifiedColumnOrder}">
        <p class="w-full is-clipped is-ellipsis">${dateFormatted}</p>
      </td>
    `;
  }
  return "";
}}
${({
  canCreatedColumnEnable,
  createdDateFormatted,
  createdColumnOrder,
  createdColumnMinWidth,
  createdColumnWidth,
}) => {
  if (canCreatedColumnEnable) {
    return `
      <td class="created-td table-td" data-width="${createdColumnWidth}" data-min-width="${createdColumnMinWidth}" data-order="${createdColumnOrder}">
        <p class="w-full is-clipped is-ellipsis">${createdDateFormatted}</p>
      </td>
    `;
  }
  return "";
}}
${({
  canKeywordColumnDisable,
  canShowFullKeywords,
  keywords,
  keywordsColumnOrder,
  keywordsColumnMinWidth,
  keywordsColumnWidth,
}) => {
  if (!canKeywordColumnDisable) {
    return `
      <td class="keyword-td table-td" data-width="${keywordsColumnWidth}" data-min-width="${keywordsColumnMinWidth}" data-order="${keywordsColumnOrder}">
        <p class="${
          canShowFullKeywords
            ? "w-full is-auto"
            : "w-full is-clipped is-ellipsis"
        }">
          ${keywords}
        </p>
      </td>
    `;
  }
  return "";
}}`;

const ListingTemplates = {
  GridItem,
  TreeHeader,
  TreeItem,
};

export default ListingTemplates;
